export const API_BASE = 'https://api-staging.mitoflux.is';
// export const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:4000";
